'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _capitalize = require('lodash/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

var _withForm = require('constructicon/with-form');

var _withForm2 = _interopRequireDefault(_withForm);

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

var _fitnessActivities = require('../../api/fitness-activities');

var _form = require('constructicon/form');

var _form2 = _interopRequireDefault(_form);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _inputField = require('constructicon/input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputSelect = require('constructicon/input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateFitnessForm = function (_Component) {
  _inherits(CreateFitnessForm, _Component);

  function CreateFitnessForm(props) {
    _classCallCheck(this, CreateFitnessForm);

    var _this = _possibleConstructorReturn(this, (CreateFitnessForm.__proto__ || Object.getPrototypeOf(CreateFitnessForm)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.state = {
      status: 'empty',
      errors: []
    };
    return _this;
  }

  _createClass(CreateFitnessForm, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          pageSlug = _props.pageSlug,
          pageId = _props.pageId,
          form = _props.form,
          onSuccess = _props.onSuccess,
          token = _props.token,
          userId = _props.userId;


      return form.submit().then(function (data) {
        _this2.setState({ errors: [], status: 'fetching' });

        var dataPayload = (0, _merge2.default)(data, {
          pageId: pageId,
          pageSlug: pageSlug,
          token: token,
          userId: userId,
          startedAt: (0, _dayjs2.default)(data.startedAt).isSame((0, _dayjs2.default)(), 'day') ? (0, _dayjs2.default)().format() : data.startedAt,
          type: data.type
        });

        return Promise.resolve().then(function () {
          return (0, _fitnessActivities.createFitnessActivity)(dataPayload);
        }).then(function (result) {
          _this2.setState({ status: 'fetched' });
          return onSuccess(result, dataPayload);
        }).catch(function (error) {
          var message = (0, _get2.default)(error, 'data.error.message') || (0, _get2.default)(error, 'data.errorMessage') || (0, _get2.default)(error, 'message') || 'There was an unexpected error';

          _this2.setState({
            status: 'failed',
            errors: message ? [{ message: message }] : []
          });

          return Promise.reject(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          disableInvalidForm = _props2.disableInvalidForm,
          form = _props2.form,
          formComponent = _props2.formComponent,
          includeDescription = _props2.includeDescription,
          includeDate = _props2.includeDate,
          includeDuration = _props2.includeDuration,
          includeElevation = _props2.includeElevation,
          includeTitle = _props2.includeTitle,
          includeType = _props2.includeType,
          includeUnit = _props2.includeUnit,
          inputField = _props2.inputField,
          submit = _props2.submit;
      var _state = this.state,
          status = _state.status,
          errors = _state.errors;


      return _react2.default.createElement(
        _form2.default,
        _extends({
          errors: errors,
          isDisabled: disableInvalidForm && form.invalid,
          isLoading: status === 'fetching',
          noValidate: true,
          onSubmit: this.handleSubmit,
          submit: submit,
          autoComplete: 'off'
        }, formComponent),
        _react2.default.createElement(
          _grid2.default,
          { spacing: { x: 0.5 } },
          includeUnit ? _react2.default.createElement(
            _gridColumn2.default,
            null,
            _react2.default.createElement(
              _grid2.default,
              { spacing: { x: 0.25 } },
              _react2.default.createElement(
                _gridColumn2.default,
                { xs: 7, sm: 7.5, md: 8, lg: 9 },
                _react2.default.createElement(_inputField2.default, _extends({}, form.fields.distance, inputField))
              ),
              _react2.default.createElement(
                _gridColumn2.default,
                { xs: 5, sm: 4.5, md: 4, lg: 3 },
                _react2.default.createElement(_inputSelect2.default, _extends({}, form.fields.unit, inputField))
              )
            )
          ) : _react2.default.createElement(
            _gridColumn2.default,
            null,
            _react2.default.createElement(_inputField2.default, _extends({}, form.fields.distance, inputField))
          ),
          includeDuration && _react2.default.createElement(
            _gridColumn2.default,
            { lg: includeElevation ? 6 : 12 },
            _react2.default.createElement(
              _grid2.default,
              { spacing: { x: 0.25 } },
              _react2.default.createElement(
                _gridColumn2.default,
                { xs: 6, sm: 6.5, md: 7, lg: 8 },
                _react2.default.createElement(_inputField2.default, _extends({}, form.fields.duration, inputField))
              ),
              _react2.default.createElement(
                _gridColumn2.default,
                { xs: 6, sm: 5.5, md: 5, lg: 4 },
                _react2.default.createElement(_inputSelect2.default, _extends({}, form.fields.durationUnit, inputField))
              )
            )
          ),
          includeElevation && _react2.default.createElement(
            _gridColumn2.default,
            { lg: includeDuration ? 6 : 12 },
            _react2.default.createElement(
              _grid2.default,
              { spacing: { x: 0.25 } },
              _react2.default.createElement(
                _gridColumn2.default,
                { xs: 7, sm: 7.5, md: 8, lg: 9 },
                _react2.default.createElement(_inputField2.default, _extends({}, form.fields.elevation, inputField))
              ),
              _react2.default.createElement(
                _gridColumn2.default,
                { xs: 5, sm: 4.5, md: 4, lg: 3 },
                _react2.default.createElement(_inputSelect2.default, _extends({}, form.fields.elevationUnit, inputField))
              )
            )
          ),
          includeType && _react2.default.createElement(
            _gridColumn2.default,
            { lg: includeDate ? 6 : 12 },
            _react2.default.createElement(_inputSelect2.default, _extends({}, form.fields.type, inputField))
          ),
          includeDate && _react2.default.createElement(
            _gridColumn2.default,
            { lg: includeType ? 6 : 12 },
            _react2.default.createElement(_inputField2.default, _extends({}, form.fields.startedAt, inputField))
          ),
          includeTitle && _react2.default.createElement(
            _gridColumn2.default,
            null,
            _react2.default.createElement(_inputField2.default, _extends({}, form.fields.title, inputField))
          ),
          includeDescription && _react2.default.createElement(
            _gridColumn2.default,
            null,
            _react2.default.createElement(_inputField2.default, _extends({}, form.fields.description, inputField, {
              maxLength: 600
            }))
          )
        )
      );
    }
  }]);

  return CreateFitnessForm;
}(_react.Component);

CreateFitnessForm.propTypes = {
  /**
   * The ID for a valid page (pageGuid for JG)
   */
  pageId: _propTypes2.default.string.isRequired,

  /**
   * The user guid
   */
  userId: _propTypes2.default.string.isRequired,

  /**
   * Units of measurement (Metric or Imperial)
   */
  uom: _propTypes2.default.oneOf(['km', 'mi']),

  /**
   * Disable form submission when invalid
   */
  disableInvalidForm: _propTypes2.default.bool,

  /**
   * The label for required distance value
   */
  distanceLabel: _propTypes2.default.string,

  /**
   * Props to be passed to the Form component
   */
  formComponent: _propTypes2.default.object,

  /**
   * Props to be passed to the InputField components
   */
  inputField: _propTypes2.default.object,

  /**
   * The onSuccess event handler
   */
  onSuccess: _propTypes2.default.func.isRequired,

  /**
   * The label for the form submit button
   */
  submit: _propTypes2.default.string,

  /**
   * The logged in users' auth token
   */
  token: _propTypes2.default.string.isRequired,

  /**
   * The initial selected fitness activity type
   */
  type: _propTypes2.default.oneOf(['walk', 'run', 'ride', 'swim', 'hike', 'wheelchair']),

  /**
   * The available fitness activity types
   */
  types: _propTypes2.default.array,

  /**
   * Include elevation in fitness activity
   */
  includeElevation: _propTypes2.default.bool,

  /**
   * Include duration in fitness activity
   */
  includeDuration: _propTypes2.default.bool,

  /**
   * Include date in fitness activity
   */
  includeDate: _propTypes2.default.bool,

  /**
   * Include title
   */
  includeTitle: _propTypes2.default.bool,

  /**
   * Include description/message
   */
  includeDescription: _propTypes2.default.bool,

  /**
   * Include distance type
   */
  includeType: _propTypes2.default.bool,

  /**
   * Include distance units
   */
  includeUnit: _propTypes2.default.bool,

  /**
   * Only allow fitness on or after this date
   */
  startDate: _propTypes2.default.string,

  /**
   * Only allow fitness on or before this date
   */
  endDate: _propTypes2.default.string
};

CreateFitnessForm.defaultProps = {
  disableInvalidForm: false,
  distanceLabel: 'Distance',
  includeDescription: true,
  includeDate: true,
  includeElevation: true,
  includeDuration: true,
  includeTitle: false,
  includeType: true,
  includeUnit: true,
  submit: 'Log fitness activity',
  type: 'walk',
  types: ['walk', 'run', 'ride', 'swim', 'wheelchair'],
  uom: 'km'
};

var form = function form(props) {
  return {
    fields: (0, _merge2.default)({
      distance: {
        type: 'number',
        label: props.distanceLabel,
        initial: '0',
        min: 0,
        required: true,
        validators: [validators.required('Please enter a ' + props.distanceLabel.toLowerCase())]
      },
      type: {
        label: 'Activity Type',
        type: 'select',
        initial: props.type,
        options: props.types.map(function (value) {
          return {
            value: value,
            label: (0, _capitalize2.default)(value)
          };
        })
      }
    }, _extends({}, props.includeTitle && {
      description: {
        label: 'Title',
        placeholder: 'Morning Exercise'
      }
    }, props.includeDescription && {
      description: {
        label: 'Description',
        type: 'contenteditable',
        placeholder: 'Describe your activity...'
      }
    }, props.includeDate && {
      startedAt: {
        label: 'Date',
        initial: (0, _dayjs2.default)().format('YYYY-MM-DD'),
        type: 'date',
        validators: [function (val) {
          return val && (0, _dayjs2.default)(val).isAfter() && "Date can't be in the future";
        }, function (val) {
          return val && props.startDate && (0, _dayjs2.default)(val).isBefore((0, _dayjs2.default)(props.startDate)) && 'Date can\'t be before ' + (0, _dayjs2.default)(props.startDate).format('MMMM Do');
        }, function (val) {
          return val && props.endDate && (0, _dayjs2.default)(val).isAfter((0, _dayjs2.default)(props.endDate)) && 'Date can\'t be after ' + (0, _dayjs2.default)(props.startDate).format('MMMM Do');
        }]
      }
    }, props.includeUnit && {
      unit: {
        type: 'select',
        label: '​',
        initial: props.uom,
        options: ['km', 'mi'].map(function (value) {
          return { value: value, label: value };
        })
      }
    }, props.includeDuration && {
      duration: {
        type: 'number',
        label: 'Time',
        initial: '0',
        min: 0
      },
      durationUnit: {
        type: 'select',
        label: '​',
        initial: 'minutes',
        options: [{ value: 'minutes', label: 'mins' }, { value: 'hours', label: 'hrs' }]
      }
    }, props.includeElevation && {
      elevation: {
        type: 'number',
        label: 'Elevation',
        initial: '0',
        min: 0
      },
      elevationUnit: {
        type: 'select',
        label: '​',
        initial: props.uom === 'mi' ? 'ft' : 'm',
        options: ['m', 'ft'].map(function (value) {
          return { value: value, label: value };
        })
      }
    }))
  };
};

exports.default = (0, _withForm2.default)(form)(CreateFitnessForm);